import { render, staticRenderFns } from "./CallBackLogin.vue?vue&type=template&id=8037fd1a"
import script from "./CallBackLogin.vue?vue&type=script&lang=js"
export * from "./CallBackLogin.vue?vue&type=script&lang=js"
import style0 from "./CallBackLogin.vue?vue&type=style&index=0&id=8037fd1a&prod&lang=css"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports